<template>
    <v-container>
        <v-row>
            <v-card outlined width="100%">
                <v-row style="margin:auto">
                    <v-col cols="4">
                        <label class="subtitle-2 font-weight-medium mb-1 d-block">Iniciales Codigo</label>
                        <v-row no-gutters>
                            <v-col cols="6" class="pr-2 ">
                                <v-select
                                    :items="prefijosLista"
                                    label="Prefijo"
                                    v-model="prefijoSeleccionado"
                                    :clearable="true"
                                    item-value="value"
                                    item-text="text"
                                    @change="onPrefijoChange"
                                    dense
                                    outlined
                                    hide-details
                                ></v-select>
                            </v-col>
                             <v-col cols="6" class="pr-2">
                                <s-text placeholder="Manual" v-model="item.Iniciales"></s-text>
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-col cols="2">
                        <s-text label="Longitud Codigo" number v-model="item.longitud" :min="0"></s-text>
                    </v-col>

                    <v-col cols="2">
                        <s-text label="Cantidad a Generar" number v-model="item.quantity" :min="0"></s-text>
                    </v-col>

                    <v-col cols="2">
                        <s-text label="Correlativo Inicio" number v-model="item.NumberInitial" :min="0"></s-text>
                    </v-col>
                </v-row>
                <v-row style="margin:auto">
                    <v-col cols="6">
                        <v-btn @click="printLabel()" small color="success" elevation="0">Generar</v-btn>
                        <v-btn class="ml-4" @click="printQR()" small color="info" elevation="0">Imprimir</v-btn>
                        <v-btn
                            class="ml-4"
                            @click="showListaDialog = true"
                            small
                            color="warning"
                            elevation="0"
                            dark>
                            <v-icon left small>mdi-format-list-bulleted-square</v-icon>
                            Imprimir por Lista
                        </v-btn>
                    </v-col>

                     <v-col cols="12">
                        <label v-for="item in itemLabel" :key="item.CodeActive">
                            {{item.CodeActive}}<br>
                        </label>
                    </v-col>
                     <!-- <v-col cols="2">
                        <v-btn @click="printQR()" small color="info" elevation="0">Imprimir</v-btn>
                    </v-col> -->
                    <v-col cols="12" v-for="item in itemLabel" :key="item.CodeActive" style="display:none">
                        <qr-code :size="50" :text="item.CodeActive" error-level="H">
                        </qr-code>
                    </v-col>
                    <v-col
                        v-for="(codigo, index) in tempListaCodigos"
                        :key="'lista-' + index + '-' + codigo"
                        data-qrlista
                        :data-qridx="index"
                        cols="12"
                        style="display:none">
                        <qr-code
                            :key="'qr-lista-' + index + '-' + codigo"
                            :size="50"
                            :text="codigo"
                            error-level="H">
                        </qr-code>
                    </v-col>
                    <!-- https://imperu.com.pe/files/MCC_MirafloresCountryClub.kmz 
                    
                    https://imperu.com.pe/files/BPP_UsosyManzanas.kmz-->

                    <!-- <v-col cols="12" v-for="item in itemLabel" :key="item.CodeActive" style="display:none"> -->
                       <!--  <qr-code :size="250" :text="'https://carreraimp10k.imperu.com.pe/'" error-level="H">
                        </qr-code> -->
                    <!-- </v-col> -->
                   
                </v-row>
            </v-card>

            <v-dialog v-model="showListaDialog" max-width="600" persistent scrollable>
                <v-card>
                    <v-card-title class="d-flex align-center" style="background: linear-gradient(90deg, #FF8F00, #FF6D00); color: #FFF;">
                        <v-icon left>mdi-format-list-bulleted-square</v-icon>
                        Imprimir QR por Lista de Códigos
                    </v-card-title>
                    <v-card-text>
                        <div class="mb-3">
                            <v-textarea
                                v-model="listaCodigosRaw"
                                label="Lista de Códigos"
                                placeholder="Ejemplo:VEHAF00010, VEHAF00011,VEHAF00016,VEHAF00018"
                                rows="9"
                                counter
                                outlined
                                dense
                                solo
                            ></v-textarea>
                        </div>
                        <v-row dense no-gutters class="mb-2">
                            <v-col cols="6">
                                <v-chip
                                    outlined
                                    color="blue"
                                    class="ma-0"
                                    small>
                                    <v-icon left small>mdi-counter</v-icon>
                                    Códigos válidos: <b class="ml-2">{{ listaParsed.total }}</b>
                                </v-chip>
                            </v-col>
                            <v-col cols="6" class="text-right">
                                <v-chip
                                    v-if="listaParsed.duplicados > 0"
                                    outlined
                                    color="amber"
                                    class="ma-0"
                                    small>
                                    <v-icon left small>mdi-alert-outline</v-icon>
                                    Duplicados omitidos: <b class="ml-2">{{ listaParsed.duplicados }}</b>
                                </v-chip>
                                <v-chip
                                    v-if="listaParsed.vacios > 0"
                                    outlined
                                    color="grey"
                                    class="ma-0 ml-2"
                                    small>
                                    <v-icon left small>mdi-minus-circle-outline</v-icon>
                                    Vacíos omitidos: <b class="ml-2">{{ listaParsed.vacios }}</b>
                                </v-chip>
                            </v-col>
                        </v-row>
                        <v-divider class="my-2"></v-divider>
                        <div v-if="listaParsed.lista.length > 0">
                            <!-- <div class="text-caption grey--text text--darken-1 font-weight-bold mb-2 text-uppercase">
                                Vista Previa
                            </div>
                            <div
                                class="d-flex flex-wrap pa-3 rounded"
                                style="max-height: 180px; overflow-y: auto; background: #FAFBFC; border: 1px solid #E5E7EB;">
                                <v-chip
                                    v-for="(c, i) in listaParsed.lista.slice(0, 50)"
                                    :key="'chip-' + i + '-' + c"
                                    small
                                    class="ma-1"
                                    color="info"
                                    outlined
                                    text-color="#0277BD"
                                    label>
                                    <v-icon left x-small>mdi-tag</v-icon>
                                    {{ c }}
                                </v-chip>
                                <span
                                    v-if="listaParsed.lista.length > 50"
                                    class="text-caption grey--text text--darken-1 self-center ml-2">
                                    ... y {{ listaParsed.lista.length - 50 }} más
                                </span>
                            </div> -->
                        </div>
                        <v-alert
                            v-if="listaParsed.total === 0 && listaCodigosRaw.trim()"
                            type="warning"
                            dense
                            outlined
                            class="mt-3"
                            icon="mdi-alert">
                            No se detectaron códigos válidos en el texto ingresado.
                        </v-alert>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            small
                            @click="onCloseListaDialog"
                            class="mr-2">
                            Cancelar
                        </v-btn>
                        <v-btn
                            @click="onClearLista"
                            small
                            text
                            color="grey"
                            :disabled="!listaCodigosRaw">
                            <v-icon left small>mdi-delete-outline</v-icon>
                            Limpiar
                        </v-btn>
                        <v-btn
                            color="primary"
                            dark
                            small
                            class="ml-2"
                            :disabled="listaParsed.total === 0"
                            @click="onImprimirLista">
                            <v-icon left small>mdi-printer</v-icon>
                            Imprimir {{ listaParsed.total }} Códigos
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            
        </v-row>
    </v-container>
</template>

<script>
import qrCode from "vue-qr-generator";

import Barcode from 'vue-barcode';

export default {
    components: {
        qrCode,
        Barcode
    },
    data: () => ({
        showListaDialog: false,
        listaCodigosRaw: "",
        tempListaCodigos: [],
        _printByListMode: false,
        itemLabel: [],
        prefijoSeleccionado: null,
        prefijosLista: [
            { text: 'CONS', value: 'CONS' },
            { text: 'EDIAF', value: 'EDIAF' },
            { text: 'EDIC', value: 'EDIC' },
            { text: 'EQCC', value: 'EQCC' },
            { text: 'EQDAF', value: 'EQDAF' },
            { text: 'EQDC', value: 'EQDC' },
            { text: 'EQDD', value: 'EQDD' },
            { text: 'MAQC', value: 'MAQC' },
            { text: 'MUEC', value: 'MUEC' },
            { text: 'OTEQ', value: 'OTEQ' },
            { text: 'SOFT', value: 'SOFT' },
            { text: 'TERC', value: 'TERC' },
            { text: 'UNIC', value: 'UNIC' },
            { text: 'VEHAF', value: 'VEHAF' },
            { text: 'VEHC', value: 'VEHC' }
        ],
        item: {
            NumberInitial: 100,
            quantity: 50,
            longitud:10,
            Iniciales: ''
        }
    }),
    computed: {
        listaParsed() {
            const raw = this.listaCodigosRaw || "";
            if (!raw || !raw.trim()) {
                return { lista: [], total: 0, duplicados: 0, vacios: 0 };
            }
            const separadores = /[,;\-\s\r\n]+/g;
            const parts = raw.split(separadores);
            const unicos = new Set();
            const lista = [];
            let vacios = 0;
            let duplicados = 0;
            for (let i = 0; i < parts.length; i++) {
                const p = parts[i] ? parts[i].trim() : "";
                if (!p) { vacios++; continue; }
                if (unicos.has(p)) { duplicados++; continue; }
                unicos.add(p);
                lista.push(p);
            }
            return {
                lista: lista,
                total: lista.length,
                duplicados: duplicados,
                vacios: vacios,
            };
        },
    },
    watch: {
        'item.Iniciales'(nuevoValor) {
            const existe = this.prefijosLista.find(p => p.value === nuevoValor);
            if (!existe) {
                this.prefijoSeleccionado = null;
            } else {
                this.prefijoSeleccionado = nuevoValor;
            }
        }
    },
    created() {
        const inicial = this.prefijosLista.find(p => p.value === this.item.Iniciales);
        if (inicial) {
            this.prefijoSeleccionado = inicial.value;
        }
    },
    methods: {
        onPrefijoChange(valor) {
            if (valor) {
                this.item.Iniciales = valor;
            }
        },

        onCloseListaDialog() {
            this.showListaDialog = false;
        },
        onClearLista() {
            this.listaCodigosRaw = "";
        },
        _encodeTextForQR(text) {
            try {
                return "data:image/svg+xml;utf8," + encodeURIComponent(
                    '<svg xmlns="http://www.w3.org/2000/svg" width="150" height="150"><text x="75" y="80" font-family="monospace" font-size="9" text-anchor="middle" fill="#333333">QR: ' + (text || "").replace(/[<>&"']/g, "") + '</text></svg>'
                );
            } catch (e) {
                return "";
            }
        },
        _fallbackPrintLista(listaCodigos, inventoryDate, pwa) {
            const codigoEmpresaImg = 'https://imperu.com.pe/Logos/Imp_inventario.png';
            for (let idx = 0; idx < listaCodigos.length; idx++) {
                const codigo = listaCodigos[idx];
                const placeholder = this._encodeTextForQR(codigo);
                pwa.document.write("<table style='margin-bottom: 800px; margin-left: 90px; margin-top: -12px' border='0'><tr><td colspan='2' style='text-align: center; font-size: 9px; font-family: Calibri'><b>" + inventoryDate +" </b></td></tr>")
                pwa.document.write(
                    "<tr><td><img height='50px' width='100px' alt='Scan me!' style='display: block;'  src='" +
                        codigoEmpresaImg +
                        "' onerror=\"this.style.display='none'\"/></td><td style='text-align: center'><div style='margin: 0px 0px 0px 0px;'><img id='qrimg-" + idx + "' alt='Scan me!' style='display: block;'  src='" +
                        placeholder +
                        "' /></div></td></tr>",
                );
                pwa.document.write("<tr><td></td><td style='text-align: center; font-size: 10px; margin-top:-50px'><b>" + codigo + "</b></td></tr>")
                pwa.document.write("</table>")
            }
        },
        onImprimirLista() {
            const parsed = this.listaParsed;
            if (!parsed || parsed.total === 0) {
                return;
            }
            const codigosLista = parsed.lista.slice();

            const currentDate = new Date();
            const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
            const currentYear = currentDate.getFullYear();
            const inventoryDate = `INVENTARIO ${currentMonth}/${currentYear}`;

            const codigoEmpresaImg = 'https://imperu.com.pe/Logos/Imp_inventario.png';

            this.tempListaCodigos = [];
            this.tempListaCodigos = codigosLista.slice();
            this._printByListMode = true;

            const self = this;

            function doPrint() {
                self.$nextTick(() => {
                    self.$nextTick(() => {
                        const listaColEls = Array.from(document.querySelectorAll("v-col[data-qrlista], [data-qrlista]"));
                        const listImgMap = new Map();
                        for (let i = 0; i < listaColEls.length; i++) {
                            const col = listaColEls[i];
                            const cid = col.getAttribute("data-qridx");
                            if (cid === null || cid === undefined) continue;
                            const idx = parseInt(cid, 10);
                            const img = col.querySelector("img");
                            if (img) listImgMap.set(idx, img);
                        }
                        const ordenados = [];
                        for (let i = 0; i < codigosLista.length; i++) {
                            ordenados.push(listImgMap.get(i) || null);
                        }
                        const missing = ordenados.filter((x) => x === null).length;
                        if (missing === codigosLista.length) {
                            setTimeout(() => {
                                const listaColEls2 = Array.from(document.querySelectorAll("v-col[data-qrlista], [data-qrlista]"));
                                const listImgMap2 = new Map();
                                for (let i = 0; i < listaColEls2.length; i++) {
                                    const col = listaColEls2[i];
                                    const cid = col.getAttribute("data-qridx");
                                    if (cid === null || cid === undefined) continue;
                                    const idx = parseInt(cid, 10);
                                    const img = col.querySelector("img");
                                    if (img) listImgMap2.set(idx, img);
                                }
                                const ordenados2 = [];
                                for (let i = 0; i < codigosLista.length; i++) {
                                    ordenados2.push(listImgMap2.get(i) || null);
                                }
                                const missing2 = ordenados2.filter((x) => x === null).length;
                                if (missing2 === codigosLista.length) {
                                    const Pagelink = "about:blank";
                                    const pwa = window.open(Pagelink, "_new");
                                    pwa.document.open();
                                    pwa.document.write(
                                        "<html><head><scri" +
                                            "pt>function step1(){\n" +
                                            "setTimeout('step2()', 10);}\n" +
                                            "function step2(){window.print();window.close()}\n" +
                                            "</scri" +
                                            "pt><style media='print'>  @media print  { @page { margin-top: 0cm; {} </style></head><body onload='step1()'></body></html>",
                                    );
                                    self._fallbackPrintLista(codigosLista, inventoryDate, pwa);
                                    pwa.document.write("");
                                    pwa.document.close();
                                    self._printByListMode = false;
                                    return;
                                }
                                self._realPrintLista(codigosLista, ordenados2, inventoryDate);
                            }, 150);
                        } else {
                            self._realPrintLista(codigosLista, ordenados, inventoryDate);
                        }
                    });
                });
            }
            setTimeout(doPrint, 30);
        },
        _realPrintLista(codigosLista, qrImgs, inventoryDate) {
            const codigoEmpresaImg = 'https://imperu.com.pe/Logos/Imp_inventario.png';
            const Pagelink = "about:blank";
            const pwa = window.open(Pagelink, "_new");
            pwa.document.open();
            pwa.document.write(
                "<html><head><scri" +
                    "pt>function step1(){\n" +
                    "setTimeout('step2()', 10);}\n" +
                    "function step2(){window.print();window.close()}\n" +
                    "</scri" +
                    "pt><style media='print'>  @media print  { @page { margin-top: 0cm; {} </style></head><body onload='step1()'></body></html>",
            );
            for (let idx = 0; idx < codigosLista.length; idx++) {
                const codigo = codigosLista[idx];
                let imgEl = qrImgs[idx];
                if (imgEl && imgEl.complete && (imgEl.currentSrc || imgEl.src)) {
                    // ok
                } else if (imgEl && (!imgEl.complete)) {
                    // dejamos que use imgEl igual
                }
                const src = imgEl && (imgEl.currentSrc || imgEl.src) ? (imgEl.currentSrc || imgEl.src) : this._encodeTextForQR(codigo);
                pwa.document.write("<table style='margin-bottom: 800px; margin-left: 90px; margin-top: -12px' border='0'><tr><td colspan='2' style='text-align: center; font-size: 9px; font-family: Calibri'><b>" + inventoryDate +" </b></td></tr>")
                pwa.document.write(
                    "<tr><td><img height='50px' width='100px' alt='Scan me!' style='display: block;'  src='" +
                        codigoEmpresaImg +
                        "' /></td><td style='text-align: center'><div style='margin: 0px 0px 0px 0px;'><img alt='Scan me!' style='display: block;'  src='" +
                        src +
                        "' /></div></td></tr>",
                );
                pwa.document.write("<tr><td></td><td style='text-align: center; font-size: 10px; margin-top:-50px'><b>" + codigo + "</b></td></tr>")
                pwa.document.write("</table>")
            }
            pwa.document.write("");
            pwa.document.close();
            this._printByListMode = false;
        },

        printLabel() {
				this.itemLabel = [];
				let initital = parseInt(this.item.NumberInitial);
				let end = parseInt(this.item.quantity) + initital
                var  j = 0

                var codigo = this.item.Iniciales
                var restante = this.item.longitud - codigo.length
                var newRestante, newCadena;

                var formato = "00000000000000000000000000000000000000";

        
				for (var i = initital; i < end; i++) {

                    if(i < 10){
                        newRestante = restante - 1
                        newCadena = formato.substring(0, newRestante)
                        codigo = this.item.Iniciales + newCadena + i;
                    }else if(i < 100){
                        newRestante = restante - 2
                        newCadena = formato.substring(0, newRestante)
                        codigo = this.item.Iniciales + newCadena + i;
                    }else if(i < 1000){
                        newRestante = restante - 3
                        newCadena = formato.substring(0, newRestante)
                        codigo = this.item.Iniciales + newCadena + i;
                    }else if(i < 10000){
                        newRestante = restante - 4
                        newCadena = formato.substring(0, newRestante)
                        codigo = this.item.Iniciales + newCadena + i;
                    }else if(i < 10000){
                        newRestante = restante - 5
                        newCadena = formato.substring(0, newRestante)
                        codigo = this.item.Iniciales + newCadena + i;
                    }

					let obj = { 
                        xNumber: i, 
                        CodeActive: codigo, 
                        Position: j 
                    };
					this.itemLabel.push(obj);
                    j = j + 1 

                    console.log(codigo, restante, newRestante, newCadena)
				}

                console.log(this.itemLabel)
                
			},
      
        printQR() {
            if (this._printByListMode && Array.isArray(this.tempListaCodigos) && this.tempListaCodigos.length > 0) {
                return;
            }

                var items = [
                    {descripcion: "TRACTOR GIRO ZERO", modelo:"Z254", numeroserie:"073118C016872"},
                    {descripcion: "CORTACESPED", modelo:"LC356", numeroserie:"20195000055"},
                    {descripcion: "CORTACESPED", modelo:"LC356", numeroserie:"20195000060"},
                    {descripcion: "CORTACESPED", modelo:"LC356", numeroserie:"20195000061"},
                    {descripcion: "DESBROZADORA", modelo:"545FR", numeroserie:"20193300084"},
                    {descripcion: "DESBROZADORA", modelo:"545FR", numeroserie:"20193300087"},
                    {descripcion: "PODADORA DE ALTURA", modelo:"525PT5S", numeroserie:"20193900091"},
                    {descripcion: "PODADORA DE ALTURA", modelo:"525PT5S", numeroserie:"20193900068"},
                    {descripcion: "PODADORA DE ALTURA", modelo:"525PT55", numeroserie:"20193900077"},
                    {descripcion: "MOTOSIERRA", modelo:"395XP", numeroserie:"20193835642"},
                    {descripcion: "CORTASETOS", modelo:"325HEA", numeroserie:"20184100019"},
                    {descripcion: "CORTASETOS", modelo:"325HEA", numeroserie:"20192500041"},
                    {descripcion: "FUMIGADORA", modelo:"423", numeroserie:"O984101"},
                    {descripcion: "PODADORA", modelo:"520", numeroserie:"NO SE RECONOCE"},
                    {descripcion: "PODADORA", modelo:"520", numeroserie:"NO SE RECONOCE"},
                ]

                var numero = [
                    {descripcion: "01",},
                    {descripcion: "02",},
                    {descripcion: "03",},
                    {descripcion: "04",},
                    {descripcion: "05",},
                    {descripcion: "06",},
                    {descripcion: "07",},
                    {descripcion: "08",},
                    {descripcion: "09",},
                    {descripcion: "10",},
                    {descripcion: "11",},
                    {descripcion: "12",},
                    {descripcion: "13",},
                    {descripcion: "14",},
                    {descripcion: "15",},
                ]
                    
            const currentDate = new Date();
            const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0'); // Mes actual (1-12)
            const currentYear = currentDate.getFullYear(); // Año actual
            const inventoryDate = `INVENTARIO ${currentMonth}/${currentYear}`; // Formato "INVENTARIO MM/YYYY"

				var imgAll = document.querySelectorAll("img");
                
				var Pagelink = "about:blank";
				var pwa = window.open(Pagelink, "_new");
				pwa.document.open();
				pwa.document.write(
					"<html><head><scri" +
						"pt>function step1(){\n" +
						"setTimeout('step2()', 10);}\n" +
						"function step2(){window.print();window.close()}\n" +
						"</scri" +
						"pt><style media='print'>  @media print  { @page { margin-top: 0cm; {} </style></head><body onload='step1()'></body></html>",
				);

                /* items.forEach((element, index) => {
                    console.log("element", element)
                        pwa.document.write("<table style='margin-bottom: 1500px; margin-left: 50px; margin-top: 10px' border='0'><tr><td colspan='2' style='text-align: center; font-size: 9px; font-family: Calibri'><b></b></td></tr>")
                        pwa.document.write(
                            "<tr><td></td><td style='text-align: left'><div style='margin: 0px 0px 0px 0px;'>"+
                            element.descripcion+ "<br>" +
                            "Modelo: " +element.modelo+ "<br>" +
                            "Nro. Serie: " +element.numeroserie+
                        "</div></td></tr>",
                        );
                        pwa.document.write("<tr><td></td><td style='text-align: center; font-size: 10px; margin-top:150px'><b></b></td></tr>")
                        pwa.document.write("</table>")
                }); */

                /* numero.forEach((element, index) => {
                    console.log("element", element)
                        pwa.document.write("<table style='margin-bottom: 1900px; margin-left: 90px; margin-top: -20px' border='0'><tr><td colspan='4' style='text-align: center; font-size: 54px; font-family: Calibri'><b></b></td></tr>")
                        pwa.document.write(
                            "<tr><td></td><td style='text-align: center;font-size: 54px;font-weight: 700;'><div style='margin: 20px 20px 20px 20px;font-size:54px'>"+
                            element.descripcion+ "<br>" +
                        "</div></td></tr>",
                        );
                        pwa.document.write("<tr><td></td><td style='text-align: center; font-size: 54px;font-weight: 700; margin-top:0px'><b></b></td></tr>")
                        pwa.document.write("</table>")
                }); */

                /*  pwa.document.write("<table style='margin-bottom: 800px; margin-left: 90px; margin-top: -12px' border='0'><tr><td colspan='2' style='text-align: center; font-size: 9px; font-family: Calibri'><b>ACTIVOS 06/2023 </b></td></tr>")
                        pwa.document.write(
                            "<tr><td></td><td style='text-align: center'><div style='margin: 0px 0px 0px 0px;'><img alt='Scan me!' style='display: block;'  src='" +
                                "dddddddddddddd" +
                                "' /></div></td></tr>",
                        );
                        pwa.document.write("<tr><td></td><td style='text-align: center; font-size: 10px; margin-top:-50px'><b>" + "Holaaa" + "</b></td></tr>")
                        pwa.document.write("</table>") */

                    imgAll.forEach((element, index) => {
                        console.log("index", index)
                        pwa.document.write("<table style='margin-bottom: 800px; margin-left: 90px; margin-top: -12px' border='0'><tr><td colspan='2' style='text-align: center; font-size: 9px; font-family: Calibri'><b>" + inventoryDate +" </b></td></tr>")
                        pwa.document.write(
                            "<tr><td><img height='50px' width='100px' alt='Scan me!' style='display: block;'  src='" +
                                'https://imperu.com.pe/Logos/Imp_inventario.png' +
                                "' /></td><td style='text-align: center'><div style='margin: 0px 0px 0px 0px;'><img alt='Scan me!' style='display: block;'  src='" +
                                element.currentSrc +
                                "' /></div></td></tr>",
                        );
                        pwa.document.write("<tr><td></td><td style='text-align: center; font-size: 10px; margin-top:-50px'><b>" + this.itemLabel.filter(x => x.Position == index)[0].CodeActive + "</b></td></tr>")
                        pwa.document.write("</table>")
                    });

                pwa.document.write("")		        
				pwa.document.close();

				
			},
    },

};
</script>
